import axiosInstance from "../instance/axiosInstance";

class AdminsListApi {
  static async adminsList(page, searchQuery) {
    let url = `/organization/admin/list?page=${page}`;
    if (searchQuery) {
      url += `&search_name=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }
  static async adminView(id, page, searchQuery) {
    let url = `/organization/admin/view/${id}?page=${page}`;
    if (searchQuery) {
      url += `&search_name=${encodeURIComponent(searchQuery)}`;
    }
    try {
      const response = await axiosInstance.get(url);
      if (response) {
        return response.data;
      }
    } catch (error) {
      return error;
    }
  }

}

export default AdminsListApi;
